// @flow
'use strict';

import CamposNfce from './campos_nfce';

export default CamposNfce;